export default "__VITE_ASSET__B8SPt3Mk__"